module.exports = __webpack_public_path__ + "static/media/all_purchases.5e7d0541.png";